import React, { PropTypes } from "react";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import Dropzone from "react-dropzone";

const FileInput = (props, context) => {
  const {
    input,
    label,
    meta: { error, touched },
    dropzoneLabel,
    groupClassName,
    id,
    ...rest
  } = props;
  const files = input.value;
  const validationState = !!error && touched ? error.state : null;
  const validationMessageKey =
    !!error && error.messageKey ? error.messageKey : null;
  const validationValues = !!error && error.values ? error.values : null;
  const scene = context.scene ? "-" + context.scene : "";

  return (
    <FormGroup
      className={[groupClassName, "file-input"]}
      controlId={id + scene}
      validationState={validationState}
    >
      {label && <ControlLabel>{label}</ControlLabel>}
      <div className="input-wrapper">
        <Dropzone
          activeClassName="active"
          className="drop-zone"
          name={name}
          onDrop={(filesToUpload) => {
            input.onFocus();
            input.onBlur(filesToUpload);
            return input.onChange(filesToUpload);
          }}
          {...rest}
        >
          <div>{dropzoneLabel}</div>
        </Dropzone>
        {!error && files && Array.isArray(files) && (
          <ul className="files-to-upload">
            {files.map((file, i) => (
              <li key={i}>{file.name}</li>
            ))}
          </ul>
        )}
        {error && touched && (
          <HelpBlock>
            <FormattedMessage
              id={validationMessageKey}
              values={validationValues}
            />
          </HelpBlock>
        )}
      </div>
    </FormGroup>
  );
};

FileInput.propTypes = {
  dropzoneLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  groupClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  isStatic: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  meta: PropTypes.object.isRequired,
  validation: PropTypes.object,
  validationKey: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/common/form/FileInput.js